import { render, staticRenderFns } from "./VisualizarPreAnaliseCredito.vue?vue&type=template&id=20ec1690&lang=pug"
import script from "./VisualizarPreAnaliseCredito.vue?vue&type=script&lang=js"
export * from "./VisualizarPreAnaliseCredito.vue?vue&type=script&lang=js"
import style0 from "./VisualizarPreAnaliseCredito.vue?vue&type=style&index=0&id=20ec1690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports